import { render, staticRenderFns } from "./MovementSlidesModal.vue?vue&type=template&id=576180f1&"
import script from "./MovementSlidesModal.vue?vue&type=script&lang=js&"
export * from "./MovementSlidesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports